import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import SocialShare from './SocialShare';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <Logo size="small" showText={true} />
          <p className="footer-description">
            {t('footer.builtWith')}
          </p>
          <SocialShare />
        </div>

        <div className="footer-section">
          <h4 className="footer-title">Support</h4>
          <div className="footer-links">
            <a 
              href="mailto:support@file-convert-hub.com" 
              className="footer-link"
              style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
            >
              <span>📧</span>
              <span>support@file-convert-hub.com</span>
            </a>
            <Link 
              to="/privacy" 
              className="footer-link"
            >
              {t('footer.privacyPolicy')}
            </Link>
          </div>
        </div>

        <div className="footer-section">
          <h4 className="footer-title">Features</h4>
          <div className="footer-links">
            <span className="footer-feature">🔒 100% Private</span>
            <span className="footer-feature">⚡ Fast Conversion</span>
            <span className="footer-feature">🌍 Works Offline</span>
            <span className="footer-feature">📱 Mobile Friendly</span>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-copyright">
          {t('footer.copyright')}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
